import { styled } from 'styled-components';
import { Card, Space } from 'antd';

export const LoginContainer = styled.main`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
`;

export const LoginCard = styled(Card)`
  width: 400px;
  text-align: center;
`;

export const FullWidthSpace = styled(Space)`
  width: 100%;
`;
